import { render, staticRenderFns } from "./wangEditor.vue?vue&type=template&id=f5628970&"
import script from "./wangEditor.vue?vue&type=script&lang=js&"
export * from "./wangEditor.vue?vue&type=script&lang=js&"
import style0 from "./wangEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../ytht-h5/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports